import React from 'react'
import EntityAdminMenu from '../admin/EntityAdminMenu'
import Link from '../lib/Link'
import {formatDate} from '../lib/util'
import {LANGUAGES} from '../../config'
import customViewRenderers from '../../components/Views'

const RowRenderer = ({entity, lang}) => {
	return (
	<div className='row'>
		<EntityAdminMenu entity={entity}/>
		{entity.title &&
			(entity.path
				?<Link to={LANGUAGES?entity.path.filter(it=>it.lang===lang)[0].p:entity.path} className='entity-title'>{entity.title}</Link>
				:entity.title
			)
		}
		{(entity.date || entity.cat) &&
			<div className='header'>
				{entity.cat && <div className='cat'>{entity.cat}</div>}
				{entity.date && <div className='date'>{formatDate(entity.date)}</div>}
			</div>
		}
	</div>
)}

const viewRenderers = Object.assign({}, {
	row: RowRenderer
}, customViewRenderers)
export default viewRenderers


// WEBPACK FOOTER //
// ./src/fm/block/ViewRenderer.js